import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { APPS, COLLECTION_NAME } from '../dummy/app';
import { STATUS_OBJECT } from '../dummy/status';
import { TestOption, ITesting } from '../interfaces/testing';
import * as moment from "moment";
import { ConvertService } from './convert.service';
import * as firebase from 'firebase/app';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  constructor(
    private db: AngularFirestore,
  ) { }


  collectionRef(collection) {
    return this.db.collection(collection)
  }

  collectionDocRef(collection, itemKey) {
    return this.db.collection(collection).doc(itemKey)
  }

  resolveDataRef() {
    // return this.db.collection("reading_batches", ref => ref.where('organizationKey', "==", "moCR5M7AHO1DA64T6Ol6"))
    return this.db.collection("students", ref => ref.where('organizationKey', "==", "moCR5M7AHO1DA64T6Ol6"))
  }

  displayName(item: any): string {
    return item ? item.name : item;
  }

  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }

  serverTimestamp() {
    return firebase.firestore.FieldValue.serverTimestamp();
  }

  displayItem(item: any): string {
    return item ? item.name : item;
  }

  admissionMovementRef() {
    return this.firestore().collection("student_admissions")
  }


  appSlideRef() {
    return this.db.collection("app_slides", ref => ref.orderBy("page_key", "desc"))
  }

  paymentTermRef(key: string) {
    return this.db.collection("academic_environment").doc(key);
  }

  testingCollectionScrollRef(textSearch: string, lastVisible: any) {
    if (textSearch !== "") {
      return this.db.collection("testing", ref =>
        ref
          .where("serial_id", "==", textSearch)
          .orderBy("page_key", "desc")
          .startAfter(lastVisible.page_key)
          .limit(APPS.SIZE)
      );
    } else {
      return this.db.collection("testing", ref =>
        ref
          .orderBy("page_key", "desc")
          .startAfter(lastVisible.page_key)
          .limit(APPS.SIZE)
      );
    }
  }
  studentPucProfileFireRef() {
    return this.firestore().collection("student_puc_profile");
  }

  testingFireRef() {
    return this.firestore().collection("testing");
  }

  invoicesFireRef() {
    return this.firestore().collection("invoices");
  }
  tuitionFeeRef() {
    return this.db.collection<any>("admission_services", ref =>
      ref.orderBy("name")
    );
  }

  testingCollectionRef(user: any, status: string, text) {
    if (text) {
      return this.db.collection("testing", ref =>
        ref
          .where("serial_id", "==", text)
          .where("create_by.key", "==", user.key)
      );
    }
    let ref = this.db.collection("testing", ref =>
      ref.orderBy("page_key", "desc").limit(APPS.SIZE)
    );
    switch (status) {
      case "all":
        ref = this.db.collection("testing", ref =>
          ref
            // .orderBy("page_key", "desc")
            .where("create_by.key", "==", user.key)
            .limit(APPS.SIZE)
        );
        break;
      case "unpaid":
        ref = this.db.collection("testing", ref =>
          ref
            .where("isPaidTest", "==", false)
            // .orderBy("page_key", "desc")
            .limit(APPS.SIZE)
        );
        break;
      case "paid":
        ref = this.db.collection("testing", ref =>
          ref
            .where("isPaidTest", "==", true)
            // .orderBy("page_key", "desc")
            .limit(APPS.SIZE)
        );
        break;
      case "own":
        ref = this.db.collection("testing", ref =>
          ref
            .where("create_by.key", "==", user.key)
            // .orderBy("page_key", "desc")
            .limit(APPS.SIZE)
        );
        break;
      default:
        break;
    }
    return ref;
  }
  trainingLevelByProgramRef(key) {
    return this.db.collection("institute_training_level", ref =>
      ref.where("program.key", "==", key)
    );
  }
  institutesRef() {
    return this.db.collection("institutes", ref =>
      ref.where("instituteType.key", "==", 1).orderBy("code")
    );
  }

  programLevelRef(programKey) {
    return this.db.collection("testLevel", ref =>
      ref.where("program.key", "==", programKey).orderBy("program_level.key")
    );
  }
  instituteProgramsRef(instituteKey) {
    return this.db.collection<any>("testType", ref =>
      ref.where("institute.key", "==", instituteKey).orderBy("code")
    );
  }
  termInstituteActiveRef(termKey, instituteKey) {
    return this.db.collection("academics_term", ref =>
      ref
        .where("term_type.key", "==", termKey)
        .where("termstatus.key", "<", 3)
        .where("institute.key", "==", instituteKey)
        .orderBy("termstatus.key")
        .orderBy("page_key", "desc")
    );
  }
  testingExistRef(form: ITesting) {
    return this
      .firestore()
      .collection("testing")
      .where("first_name", "==", form.first_name.trim().toUpperCase())
      .where("last_name", "==", form.last_name.trim().toUpperCase())
      .where("gender.key", "==", form.gender.key)
      .where("dobKey", "==", form.dobKey)
      .orderBy("page_key", "desc")
      .limit(1);
  }

  instituteActiveTermRef(key: string) {
    return this.db.collection("academic_environment").doc(key);
  }

  shiftMovementDocRef(key) {
    return this.db.collection("shift_movements").doc<any>(key);
  }

  academicFireRef() {
    return this
      .firestore()
      .collection("academic_environment")
      .doc("academic_environment");
  }

  configFireRef() {
    return this
      .firestore()
      .collection("testing_options")
      .doc("general");
  }

  academicRef() {
    return this.db
      .collection("academic_environment")
      .doc("academic_environment");
  }
  userRefDoc(uid: string) {
    return this.db.collection("users").doc<any>(uid);
  }

  userFRef(uid: string) {
    return this.firestore().collection("users").doc(uid);
  }
  studentFireRef() {
    return this.firestore().collection("students");
  }

  admissionFireRef() {
    return this.firestore().collection("admission_movement");
  }

  enrollmentFireRef() {
    return this.firestore().collection("enrollment_movements");
  }

  expiredFeeDate(admisionDate: Date, config: TestOption) {
    return moment(admisionDate)
      .add(config.expired_fee_peroid, "days")
      .toDate();
  }
  settingFireStore() {
    return this
      .firestore()
      .collection("testing_options")
      .doc("general");
  }

  sysSetting() {
    return this.db.collection("testing_options").doc("general");
  }
  registerTestFireRef() {
    return this.firestore().collection('general_register_testing')
  }



  studentRef() {
    return this.db.collection('students')
  }

  admissionRef(lastVisible: any, organizationKey) {
    return this.db.collection('organizations').doc(organizationKey).collection('student_admissions', ref => {
      let condition = ref.where("organizationKey", "==", organizationKey)
        .where("isDelete", "==", false)

      if (lastVisible) {
        const startAfter = lastVisible["updated_at"];
        condition = condition.orderBy("updated_at", "desc")
          .startAfter(startAfter)
      }
      else {
        condition = condition.orderBy("updated_at", "desc")
      }
      return condition.limit(APPS.SIZE)
    })
  }

  registerTestRef(lastVisible: any, organizationKey, termKey, programKey) {
    return this.db.collection('organizations').doc(organizationKey)
      .collection('terms').doc(termKey)
      .collection('general_register_testing', ref => {
        let condition = ref.where("isDelete", "==", false)
        if (programKey && programKey !== 'submitted') {
          condition = condition.where("classKey", "==", programKey)
        }
        if (lastVisible) {
          const startAfter = lastVisible["updated_at"];
          condition = condition.orderBy("updated_at", "desc")
            .startAfter(startAfter)
        }
        else {
          condition = condition.orderBy("updated_at", "desc")
        }
        return condition.limit(APPS.SIZE)
      })
  }

  autoColelctionStudentRef(collection) {
    return this.db.collection(collection, ref => ref.where('generalPlacementTestStarting', '==', true).where('status.key', '==', 1).limit(APPS.SIZE));
  }



  searchfilterStudentRef(collectionName: string, field: string, text: any) {
    if (text && !text.key) {
      const search = text.toUpperCase();
      const end = search.replace(/.$/, c => String.fromCharCode(c.charCodeAt(0) + 1));
      return this.db.collection(collectionName, ref =>
        ref
          .where('generalPlacementTestStarting', '==', true)
          .where("status.key", "==", 1)
          .where(field, ">=", search)
          .where(field, '<', end)
          .orderBy(field)
          .limit(APPS.SIZE)
      );
    }
    return this.db.collection(collectionName, ref =>
      ref
        .where('generalPlacementTestStarting', '==', true)
        .where("status.key", "==", 1)
        .orderBy(field)
        .limit(APPS.SIZE)
    );

  }


  autoColelctionRef(collection) {
    return this.db.collection(collection, ref => ref.where('status.key', '==', 1).limit(APPS.SIZE));
  }



  searchfilterRef(collectionName: string, field: string, text: any) {
    if (text && !text.key) {
      const search = text.toUpperCase();
      const end = search.replace(/.$/, c => String.fromCharCode(c.charCodeAt(0) + 1));
      return this.db.collection(collectionName, ref =>
        ref
          .where("status.key", "==", 1)
          .where(field, ">=", search)
          .where(field, '<', end)
          .orderBy(field)
          .limit(APPS.SIZE)
      );
    }
    return this.db.collection(collectionName, ref =>
      ref
        .where("status.key", "==", 1)
        .orderBy(field)
        .limit(APPS.SIZE)
    );

  }

  trainingBatchRef(order) {
    return this.db.collection("training_batches", ref => ref.orderBy(order))
  }
  trainingBatchFireRef() {
    return this.firestore().collection("training_batches")
  }

  trainingStudentRef(order) {
    return this.db.collection("students", ref => ref.orderBy(order).limit(APPS.SIZE))
  }

  trainingTutorRef(order) {
    return this.db.collection("tutors", ref => ref.orderBy(order).limit(APPS.SIZE))
  }

  trainingStudentFilterRef(field: string, search: any) {
    if (search) {
      if (search.key) {
        return this.db.collection("students", ref => ref
          .where("key", "==", search.key)
        )
      }
      return this.db.collection("students", ref => ref
        .where(field, ">=", search)
        .orderBy(`${field}`)
        .limit(APPS.SIZE)
      )
    }
    return this.db.collection("students", ref => ref
      .orderBy("page_key")
      .limit(APPS.SIZE)
    )
  }

  autoColelctionByCompanyRef(collection, companyKey) {
    return this.db.collection('company').doc(companyKey).collection(collection, ref => ref.where('status.key', '==', 1).limit(APPS.SIZE));
  }


  searchfilterByCompanyRef(collectionName: string, companyKey: string, field: string, text: any) {
    if (text && !text.key) {
      const search = text.toUpperCase();
      const end = search.replace(/.$/, c => String.fromCharCode(c.charCodeAt(0) + 1));
      return this.db.collection(collectionName, ref =>
        ref
          .where('company.key', '==', companyKey)
          .where("status.key", "==", 1)
          .where(field, ">=", search)
          .where(field, '<', end)
          .orderBy(field)
          .limit(APPS.SIZE)
      );
    }
    return this.db.collection(collectionName, ref =>
      ref
        .where('company.key', '==', companyKey)
        .where("status.key", "==", 1)
        .orderBy(field)
        .limit(APPS.SIZE)
    );

  }


  subjectSearchRef(keyword) {
    return this.db.collection<any>("subjects", ref =>
      ref
        .where("name", ">=", keyword)
        .orderBy("name")
        .limit(APPS.SIZE)
    );
  }

  subjectRef(ref?) {
    return this.db.collection("subjects", ref)
  }

  tutorRef(ref?) {
    return this.db.collection("tutors", ref)
  }

  trainingProgramRef(ref?) {
    return this.db.collection("training_programs", ref)
  }
  userRef() {
    return this.db.collection(`users`)
  }

  levelRef(ref?) {
    return this.db.collection("level", ref)
  }

  degreeRef(ref?) {
    return this.db.collection("degree", ref)
  }

  districtRef(ref?) {
    return this.db.collection("districts", ref)
  }

  provinceRef(ref?) {
    return this.db.collection("provinces", ref)
  }

  sessionRef(ref?) {
    return this.db.collection("sessions", ref)
  }

  sessionByShiftRef(key: string) {
    return this.db.collection("sessions", ref => ref.where("shiftKey", "==", key))
  }

  termRef(ref?) {
    return this.db.collection("terms", ref)
  }

  checkExistRegisterRef(refNo, collection, feild) {
    return this.db.collection(collection, ref => ref
      .where("isDelete", "==", false)
      // .where("organizationKey", "==", companyKey)
      .where(feild, "==", refNo.toString().trim())
      .limit(1)
    )
  }
  batch() {
    return this.db.firestore.batch();
  }

  batchCollectionRef() {
    return this.db.firestore;
  }

  shiftRef(ref?) {
    return this.db.collection("shifts", ref)
  }

  programRef() {
    return this.db.collection('resource_programs')
  }

  readingBatchLevelRef() {
    return this.db.collection(COLLECTION_NAME.READING_LEVEL, ref => ref.orderBy("order"))
  }


  readingBatchRef() {
    return this.db.collection(COLLECTION_NAME.READING_BATCHES, ref => ref.orderBy("name"))
  }


  getStudent(school) {
    return this.db.collection("students", ref => ref.where('organizationKey', '==', school.key).where('isReset', '==', false).limit(100))
  }


  adprogramRef(ref?) {
    return this.db.collection("programs", ref)
  }

  adprogramCollectRef() {
    return this.db.collection("general_placement_test")
  }

  // adprogramCollectRef(level) {
  //   return this.db.collection("programs", ref => ref.where('levelKey', "==", level).orderBy('order'))
  // }

  grammarInUseRef() {
    return this.db.collection('grammar_in_use')
  }

  placementTestRef() {
    return this.db.collection('placement_test')
  }

  generalPlacementTestRef() {
    return this.db.collection('general_placement_test', ref => ref.orderBy('page_key'))
  }

  classRoomRef() {
    return this.db.collection('classrooms', ref => ref.orderBy('page_key'))
  }

  classroomScheduleRef(key: string) {
    return this.db.collection('classrooms').doc(key).collection("schedules")
  }

  classroomReadingRef(key: string) {
    return this.db.collection('classrooms').doc(key).collection("class_reading_book")
  }

  classRoomFireRef() {
    return this.db.firestore.collection('classrooms')
  }

  statisticBatchRef() {
    return this.db.firestore.collection('organization_statistic')
  }

  moduleRef() {
    return this.db.collection('resource_modules');
  }
  academicYearRef() {
    return this.db.collection('academic_year')
  }
  companyRef() {
    return this.db.collection('organizations')
  }
  companyFireRef() {
    return this.firestore().collection('organizations')
  }

  skillRef() {
    return this.db.collection('resource_skills')
  }

  activityTypeRef() {
    return this.db.collection('resource_activity_types')
  }

  difficultyRef() {
    return this.db.collection('resource_difficulty')
  }

  authorRef() {
    return this.db.collection('book_store_authors')
  }

  genresRef() {
    return this.db.collection('book_store_genres')
  }

  sectionsRef() {
    return this.db.collection('book_store_sections')
  }

  publishersRef() {
    return this.db.collection('book_store_publishers')
  }

  booksRef() {
    return this.db.collection('book_store_books')
  }

  bookClubRef() {
    return this.db.collection('book_store_books', ref => ref.where('bookClub', '==', true))
  }

  activityColRef() {
    return this.db.collection(COLLECTION_NAME.ACTIVITY)
  }

  activityByModuleDBRef(moduleKey) {
    return this.db.collection("resource_activities", ref => ref.where("moduleKey", "==", moduleKey))
  }

  resourceActivityRef() {
    return this.db.collection("resource_activities")
  }
  moduleByLessonRef(lessonKey) {
    return this.db.collection("resource_modules", ref => ref.where("lessonKey", "==", lessonKey))
  }

  createId() {
    return this.db.createId();
  }

  firestoreRef() {
    return this.db
  }

  userProfileRef() {
    return this.db.collection("users")
  }

  levelColRef() {
    return this.db.collection('resource_levels')
  }

  lessonColRef() {
    return this.db.collection('resource_lessons')
  }

  userMemberRef(lastVisible: any, accountTypeKey: any, appNameKey) {
    return this.db.collection(COLLECTION_NAME.STUDENTS, ref => {
      let condition = ref.where('accountType.key', "==", accountTypeKey)
        .where("isDelete", "==", false)
        .where("status.key", "==", 1)
      if (appNameKey) {
        condition = condition.where("appName.key", '==', appNameKey)
      }
      if (lastVisible) {
        const startAfter = lastVisible["updated_at"];
        condition = condition.orderBy("updated_at", "desc")
          .startAfter(startAfter)
      }
      else {
        condition = condition.orderBy("updated_at", "desc")
      }

      return condition.limit(APPS.SIZE)
    })
  }


  userMemberListRef(accountTypeKey: any) {
    return this.db.collection(COLLECTION_NAME.STUDENTS, ref => {
      let condition = ref.where('accountType.key', "==", accountTypeKey)
        .where("isDelete", "==", false)
        .where("status.key", "==", 1)
        .orderBy("updated_at", "desc")
        .limit(APPS.SIZE)
      return condition
    })
  }

  userMemberSearchListRef(accountTypeKey: any, orderBy?: any, field?: string, search?: any) {
    return this.db.collection(COLLECTION_NAME.STUDENTS, ref => {
      let condition = ref.where('accountType.key', "==", accountTypeKey)
        .where("isDelete", "==", false)
        .where("status.key", "==", 1)
      if (search) {
        if (search.key)
          condition = condition.where("key", "==", search.key)
        else
          condition = condition.where(field, ">=", search).orderBy(`${field}`)
      }
      else {
        if (orderBy)
          condition = condition.orderBy("updated_at", "desc")
        else
          condition = condition.orderBy(orderBy)
      }
      return condition.limit(APPS.SIZE)
    })
  }

  bookRef(collectionName, lastVisible: any, displayStatusKey: any, bookTypeKey: any, levelKey?: any, search?: any) {
    return this.db.collection(collectionName, ref => {
      let condition = ref.where("organizationKey", "==", null)
        .where('license', "==", bookTypeKey)
      if (displayStatusKey === STATUS_OBJECT.deleted.key) {
        condition = condition.where("isDelete", "==", true)
      }
      else {
        condition = condition.where("isDelete", "==", false)
          .where("register_status.key", "==", displayStatusKey);
      }
      if (levelKey) {
        condition = condition.where("level.key", "==", levelKey);
      }
      if (search) {
        condition = condition
          .where("keyword", ">=", ConvertService.toCapitalize(search))
          .orderBy('keyword')
      }
      if (lastVisible) {
        const startAfter = lastVisible["updated_at"];
        condition = condition.orderBy("updated_at", "desc")
          .startAfter(startAfter)
      }
      else {
        condition = condition.orderBy("updated_at", "desc")
      }
      return condition.limit(APPS.SIZE)
    })
  }

  bookstoreRef(collectionName, lastVisible: any, displayStatusKey: any) {
    return this.db.collection(collectionName, ref => {
      let condition = ref.where("organizationKey", "==", null)
      if (displayStatusKey === STATUS_OBJECT.deleted.key) {
        condition = condition.where("isDelete", "==", true)
      }
      else {
        condition = condition.where("isDelete", "==", false)
          .where("register_status.key", "==", displayStatusKey);
      }
      if (lastVisible) {
        const startAfter = lastVisible["updated_at"];
        condition = condition.orderBy("updated_at", "desc")
          .startAfter(startAfter)
      }
      else {
        condition = condition.orderBy("updated_at", "desc")
      }
      return condition.limit(APPS.SIZE)
    })
  }

  lectureTypeRef(ref?) {
    return this.db.collection("lecture_types", ref)
  }

  facultyRef(ref?) {
    return this.db.collection("faculties", ref)
  }
  floorRef(ref?) {
    return this.db.collection("floors", ref)
  }
  curricularRef(ref?) {
    return this.db.collection("curricular", ref)
  }
  roomsRef(ref?) {
    return this.db.collection("rooms", ref)
  }
  settingsRef(ref?) {
    return this.db.collection("settings", ref)
  }
  environmentRef() {
    return this.db.collection("system_environments").doc('general')
  }


  countryRef(ref?) {
    return this.db.collection("countries", ref)
  }
  analyticsRef(ref?) {
    return this.db.collection("analytics", ref)
  }

  holidayRef(ref?) {
    return this.db.collection("holiday", ref)
  }
  firestore() {
    return this.db.firestore;
  }
  majorFireRef() {
    return this.firestore().collection("majors")
  }

  curricularFireRef() {
    return this.firestore().collection("curricular")
  }
  curricularCourseRef(ref?) {
    return this.db.collection("curricular_courses", ref)
  }

  dbRef() {
    return this.db;
  }
  majorRef(ref?) {
    return this.db.collection("majors", ref)
  }
  buildingRef(ref?) {
    return this.db.collection("buildings", ref)
  }
  campusRef(ref?) {
    return this.db.collection("campus", ref)
  }
  courseTypeRef(ref?) {
    return this.db.collection("course_types", ref)
  }

  nationalityRef(ref?) {
    return this.db.collection("nationalities", ref)
  }

  studentsRef(ref?) {
    return this.db.collection("students", ref)
  }


  collection(name) {
    return this.db.collection(name);
  }
  grammarInUseDataRef(section: boolean) {
    return this.db.collection('grammar_in_use', ref => ref.where('section', '==', section))
  }

  roomTypeRef(ref?) {
    return this.db.collection("room_types", ref)
  }

  resourceLessonRef(ref?) {
    return this.db.collection(COLLECTION_NAME.LESSON, ref)
  }
  resourceLevelRef(ref?) {
    return this.db.collection(COLLECTION_NAME.LEVEL, ref)
  }


  resourceRef(collectionName, lastVisible: any, displayStatusKey: any, organizationKey: string, lessonKey?: any, programKey?: any, trailAccount?: any, testingAccount?: any, levelKey?: any, search?: any) {
    return this.db.collection(collectionName, ref => {
      let condition = ref.where("organizationKey", "==", organizationKey)
      if (displayStatusKey === STATUS_OBJECT.deleted.key) {
        condition = condition.where("isDelete", "==", true)
      }
      else {
        condition = condition.where("isDelete", "==", false)
          .where("register_status.key", "==", displayStatusKey);
      }
      if (search) {
        return condition.where('name', ">=", search).orderBy('name');
      }
      if (levelKey) {
        condition = condition.where('levelKeys', 'array-contains', levelKey)
      }
      if (lessonKey) {
        condition = condition.where("lessonKey", "==", lessonKey)
      }
      if (programKey) {
        condition = condition.where("programKey", "==", programKey)
      }
      if (trailAccount) {
        condition = condition.where("trailAccount", "==", true)
      }
      if (testingAccount) {
        condition.where("placementTestStarting", "==", testingAccount)
      }
      if (lastVisible) {
        const startAfter = lastVisible["updated_at"];
        condition = condition.orderBy("updated_at", "desc")
          .startAfter(startAfter)
      }
      else {
        condition = condition.orderBy("updated_at", "desc")
      }
      return condition.limit(APPS.SIZE)
    })
  }

  dictionaryRef(collectionName, lastVisible: any, displayStatusKey: any, organizationKey: string) {
    return this.db.collection(collectionName, ref => {
      let condition = ref.where("organizationKey", "==", organizationKey)
      if (displayStatusKey === STATUS_OBJECT.deleted.key) {
        condition = condition.where("isDelete", "==", true)
      }
      else {
        condition = condition.where("isDelete", "==", false)
          .where("register_status.key", "==", displayStatusKey);
      }
      if (lastVisible) {
        const startAfter = lastVisible["updated_at"];
        condition = condition.orderBy("updated_at", "desc")
          .startAfter(startAfter)
      }
      else {
        condition = condition.orderBy("updated_at", "desc")
      }
      return condition.limit(APPS.SIZE)
    })
  }

  activityByModuleRef(moduleKey: any, activityTypeKey, organizationKey: string) {
    return this.db.collection(COLLECTION_NAME.ACTIVITY, ref => ref
      .where("organizationKey", "==", organizationKey)
      .where('moduleKey', '==', moduleKey)
      .where('activityTypeKey', '==', activityTypeKey)
      .orderBy("updated_at", "desc"))
  }

  activityByModuleColRef(moduleKey: any) {
    return this.db.collection(COLLECTION_NAME.ACTIVITY, ref => ref
      .where('moduleKey', '==', moduleKey)
      .where('isDelete', "==", false))
  }

  activityRef(lastVisible: any, moduleKey: any, displayStatusKey, organizationKey: string) {
    return this.db.collection(COLLECTION_NAME.ACTIVITY, ref => {
      let condition = ref.where("organizationKey", "==", organizationKey).where('moduleKey', '==', moduleKey)
      if (displayStatusKey === STATUS_OBJECT.deleted.key) {
        condition = condition.where("isDelete", "==", true)
      }
      else {
        condition = condition.where("isDelete", "==", false).where("register_status.key", "==", displayStatusKey);
      }
      if (lastVisible) {
        const startAfter = lastVisible["updated_at"];
        condition = condition.orderBy("updated_at", "desc").startAfter(startAfter)
      }
      else {
        condition = condition.orderBy("updated_at", "desc")
      }
      return condition.limit(APPS.SIZE)
    })
  }

  listRef(collectionName, orderBy) {
    return this.db.collection(collectionName, ref => ref.where("isDelete", "==", false)
      .where("register_status.key", "==", 2)
      .orderBy(orderBy)
    )
  }

  storeDocRef(key) {
    return this.db.collection("organizations").doc(key);
  }

  academicYearFireRef() {
    return this.firestore().collection("academic_year");
  }

  collectionFireRef(collectionName) {
    return this.firestore().collection(collectionName);
  }

}



export const searchFilterBy = [
  { key: "phoneNumber", text: "Phone Number" },
  { key: "fullName", text: "Full Name" },
  { key: "firstName", text: "First Name" },
  { key: "lastName", text: "Last Name" },
];


export const searchFilterSubject = [
  { key: "code", text: "Code" },
  { key: "keyword", text: "Name" },
];
